var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Crear Lista de Distribución" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("GuardarButton", {
            attrs: { disabled: _vm.form.isDirty ? _vm.hasErrors : false },
            on: { click: _vm.handleGuardarClick }
          })
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          _c(
            "v-stepper-header",
            [
              _c(
                "v-stepper-step",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    complete:
                      _vm.pasoActivoIndex > _vm.pasos.informacionGeneral.step,
                    step: _vm.pasos.informacionGeneral.step
                  }
                },
                [_vm._v("Información General")]
              )
            ],
            1
          ),
          _c(
            "v-stepper-items",
            { staticClass: "cardnew" },
            [
              _c(
                "v-stepper-content",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: { step: _vm.pasos.informacionGeneral.step }
                },
                [
                  _c("ListaDistribucionForm", {
                    on: {
                      change: _vm.handleFormChange,
                      estadoSwitch: _vm.handleEstadoSwitch
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "Lista de Distribución"
          }),
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.crear.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.crear.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacionCerrar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }